import Vue from "vue";
import vuex from "vuex";
import dynamic from "./module/dynamic"

Vue.use(vuex);

export default new vuex.Store({
  namespaced: true,
  modules: {
    dynamic
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js